export default "__VITE_ASSET__B4POWy4a__"